import React from 'react'
import { Page, Text, Button, Tabs, Spacer, Checkbox } from '@geist-ui/core'

const Home = () => (
  <div style={{ width: '100vw', height: '100vh',display: 'flex', justifyContent: 'center'}}>
    <div style={{ maxWidth: 500, minWidth: 375 }}>
    <Tabs initialValue="react">
      <Tabs.Item label="react文档" value="react">
        <div style={{ padding: 12 }}>
        <Checkbox checked={true} type="success">使用 Effect 进行同步
  </Checkbox>
  <Spacer h={.5} />
  
  <Checkbox checked={false} type="success">你可能不需要 Effect
  </Checkbox>
  <Spacer h={.5} />

  <Checkbox checked={false} type="success">响应式 Effect 的生命周期
  </Checkbox>
  

        </div>
  
      </Tabs.Item>
      <Tabs.Item label="Javascript Info" value='Javascript Info'>
        
      </Tabs.Item>
    </Tabs>
    </div>
  </div>
)

export default Home
